import { useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { authHeaders, handleUnauthorized } from "@/lib/pin";
import { getSections, visibleQuestions, formatAnswer } from "@/data/questionnaire";
import { businessForAi, belongsToCurrent } from "@/data/business";
import { computeStrategy, strategyToText } from "@/data/strategy";
import { loadAll, loadWeights, formatDate } from "@/lib/storage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const subToText = (sub) =>
  getSections(sub.businessType).map((s) => `[${s.title}]\n` + visibleQuestions(s, sub.answers).map((q) => `- ${q.text}: ${formatAnswer(q, sub.answers[q.id]) || "(non risposto)"}`).join("\n")).join("\n") +
  `\n\n${strategyToText(computeStrategy(sub.answers, loadWeights(), sub.businessType))}`;

export const EventAiProposal = ({ ev, onApply }) => {
  const completed = loadAll().filter((s) => s.status === "completed" && belongsToCurrent(s));
  const [picked, setPicked] = useState(completed[0]?.id || "");
  const [busy, setBusy] = useState(false);

  const propose = async () => {
    const sub = completed.find((s) => s.id === picked);
    if (!sub) return;
    setBusy(true);
    try {
      const res = await fetch(`${API}/scheda-evento`, {
        method: "POST", headers: { "Content-Type": "application/json", ...authHeaders() },
        body: JSON.stringify({ business: businessForAi(), event: { title: ev.title, date: ev.date, type: ev.type, guests: ev.guests, spaces: ev.spaces, menu: ev.menu }, questionnaire: subToText(sub) }),
      });
      handleUnauthorized(res);
      if (!res.ok) throw new Error((await res.json().catch(() => ({}))).detail || `Errore ${res.status}`);
      const data = await res.json();
      onApply(data);
      toast.success("Timeline, briefing e checklist aggiornati dall'AI");
    } catch (e) {
      toast.error(`Proposta non riuscita: ${e.message}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="no-print rounded-2xl border border-[#D99B26]/50 bg-[#FFFBF2] p-5 flex flex-wrap items-end gap-4" data-testid="event-ai-proposal">
      <div className="flex-1 min-w-[240px]">
        <div className="flex items-center gap-2"><Sparkles className="text-[#D99B26]" size={18} /><p className="eyebrow">Proposta AI dal questionario</p></div>
        <p className="text-sm text-[#5C4D46] mt-1">Timeline, briefing e checklist riscritti sulle criticità emerse dalle risposte dei titolari (es. sala-cucina, extra, preventivi).</p>
        {completed.length > 0 ? (
          <select className="w-full min-h-[44px] rounded-xl border border-[#E3D5C3] bg-white px-3 mt-3 text-sm" value={picked} onChange={(e) => setPicked(e.target.value)} data-testid="event-ai-pick">
            {completed.map((s) => <option key={s.id} value={s.id}>{s.respondent || "Senza nome"} · {formatDate(s.completedAt || s.createdAt)}</option>)}
          </select>
        ) : (
          <p className="text-sm italic text-[#B0A096] mt-3">Nessun questionario completato: compilane uno prima.</p>
        )}
      </div>
      <button className="btn btn-primary" onClick={propose} disabled={!picked || busy} data-testid="event-ai-btn">
        <Sparkles size={18} /> {busy ? "Sto scrivendo…" : "Proponi con l'AI"}
      </button>
    </div>
  );
};
